import { isString } from 'lodash';

export function getContentEditableType(type: string) {
  return `node-contenteditable-type-${type}`;
}

export function getContentEditableTypeFromClassName(
  classList: DOMTokenList | string
) {
  const arr = Array.from(isString(classList) ? classList.split(' ') : classList);
  return arr.find((item) => item.includes('node-contenteditable-type-'))
    ?.replace('node-contenteditable-type-', '') || '';
}

export function getContentEditableIdx(idx: string) {
  return `node-contenteditable-idx-${idx}`;
}

/**
 * Whether a blurred contenteditable's content should be written back to the form.
 *
 * Blocks render with their merge tags already resolved — an attached listing's
 * address replaces `{{listing.address}}` before the node becomes editable — so
 * the DOM never matches the stored template and a plain focus/blur used to
 * persist the resolved text over it. The tag was then gone for good: changing
 * the listing had nothing left to re-resolve.
 *
 * Compare against what the node held at focus instead. No snapshot means the
 * focus was never observed, which is treated as untouched — declining to save
 * loses a keystroke, saving blindly loses the template.
 */
export function shouldCommitContentEditable(
  contentOnFocus: string | undefined,
  contentOnBlur: string
) {
  if (contentOnFocus === undefined) return false;
  return contentOnFocus !== contentOnBlur;
}

export function getContentEditableIdxFromClassName(
  classList: DOMTokenList | string
) {
  const arr = Array.from(isString(classList) ? classList.split(' ') : classList);
  return arr.find((item) => item.includes('node-contenteditable-idx-'))
    ?.replace('node-contenteditable-idx-', '') || '';
}
